import React from 'react';
import { useHistory } from 'react-router-dom';
import { useAuthorization } from '../../components/Authorization/useAuthorization';
import { MedicalCenterForm } from '../../components/MedicalCenters/MedicalCenter';
import { HandleApiError } from '../../components/Notifications/APIErrorHandler';
import { Success } from '../../components/Notifications/Notifications';
import { useMedicalCenters } from './Hooks';

export const CreateMedicalCenterContainer = (props) => {
    const history = useHistory();
    const [, , isAuthorized] = useAuthorization();
    const tenantId = new URLSearchParams(props.location?.search).get('tenantId');
    const isSuperAdmin = isAuthorized(['Tenant.View']);
    const [, , , , create] = useMedicalCenters(tenantId);
    const backPath = tenantId
        ? `/admin/settings/medicalcenters?tenantId=${encodeURIComponent(tenantId)}`
        : '/admin/settings/medicalcenters';

    const handleCreate = async (values) => {
        try {
            await create({ name: values.name, userIds: values.userIds ?? [] });
            Success('medicalCenterNotifications.created');
            history.push(backPath);
        } catch (error) {
            HandleApiError(error);
        }
    };

    return (
        <MedicalCenterForm
            initialValues={{ name: '', userIds: [] }}
            onSubmit={handleCreate}
            onCancel={() => history.push(backPath)}
            tenantId={tenantId}
            isSuperAdmin={isSuperAdmin}
        />
    );
};
